/*
 * @Date: 2025-07-10 08:52:48
 */
import { post } from "@/utils/commonAxios";

/**
 * 获取近期招聘列表
 * @returns
 */
export const getRecentRecruitment = (pages) =>
  post("/api/recruit/getRecent", pages, {
    baseURL: `${process.env.VUE_APP_BASE_API}-core`,
  });

/**
 * 获取招聘详情
 * @param { String } id
 * @returns
 */
export const getRecentDetailsById = (id) =>
  post(
    "/api/recruit/detail",
    { id },
    { baseURL: `${process.env.VUE_APP_BASE_API}-core` }
  );

/**
 * 保存用户上传的简历信息
 * @param {*} data
 * @returns
 */
export const addUserResume = (data) =>
  post("/api/recruitDeliver/deliverAdd", data, {
    baseURL: `${process.env.VUE_APP_BASE_API}-core`,
  });
